import Tag from "@shared/components/tag/Tag";
import TunningIcon from "@svg/explore/tunningIcon";
import SwapIcon from "@svg/explore/swapp";
import { toFarsiNumber } from "@utils/digits";
import { modalActions } from "@context/modals";
import { MODAL_TYPES } from "types/modals";
import classNames from "classnames";
import ExploreTypeMobile from "@modules/new-explore/sidebar/mobile/mobile-select-type";
import { useEffect, useState } from "react";
import { useAppContext } from "@context/app";
import {
  TAG_COLOR,
  TAG_SIZE,
  TAG_STYLE,
  TAG_TYPE,
} from "@shared/components/tag";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { ExploreFilterSchemaFields } from "@modules/new-explore/types";
import { useLayoutContext } from "@context/layout";
import { useExploreSort } from "@modules/new-explore/hooks/useExploreSort";
import { useIsMobile } from "@shared/hooks/useIsMobile";

const ExploreMobileHeader: React.FC = () => {
  const { showFestivalBanner } = useAppContext();
  const isMobileModal = useIsMobile(1024);
  const layoutData = useLayoutContext();
  const { removeFilterByValue, visibleActiveFilters, getTermLabel } =
    useExplore();
  const { sortItems, activeSortLabel } = useExploreSort();

  const [showBanner, setShowBanner] = useState(showFestivalBanner);

  useEffect(() => {
    const showBannerHandler = () => {
      setShowBanner(window.scrollY < 500);
    };

    window.addEventListener("scroll", showBannerHandler);
    return () => {
      window.removeEventListener("scroll", showBannerHandler);
    };
  }, []);

  useEffect(() => {
    setShowBanner(showFestivalBanner);
  }, [showFestivalBanner]);

  const isAdmin = layoutData?.isAdmin || false;

  const openExploreFilter = () => {
    modalActions.addModal(MODAL_TYPES.EXPLORE_FILTER, {
      config: {
        hideCloseIcon: true,
        useMobileClassName: Boolean(isMobileModal),
        modalClassName: " !h-[100vh] max-h-svh ",
      },
    });
  };

  const handleOpenSortItemsModal = () => {
    modalActions.addModal(MODAL_TYPES.EXPLORE_SORT_MODAL, {
      config: {
        hideCloseIcon: true,
        modalHeaderClassName: "hidden",
      },
    });
  };

  const filterCount = Object.values(visibleActiveFilters || {}).reduce(
    (prev, item) => prev + item.filter_value.length,
    0
  );

  return (
    <div
      className={classNames(
        "lg:hidden block pt-2  sticky h-[max-content] border-b border-fds-divider w-full z-10 bg-white transition-all ease-linear duration-150",
        showBanner && showFestivalBanner
          ? isAdmin
            ? "top-[calc(7.0125rem+50px)]"
            : "top-[7.2125rem]"
          : isAdmin
            ? "top-[calc(3.7125rem+50px)]"
            : "top-[3.7125rem]"
      )}
    >
      <ExploreTypeMobile />

      <div className="flex pr-4 pl-px py-3.5   gap-x-1.5  no-scrollbar overflow-scroll ">
        {sortItems.length ? (
          <Tag
            startIcon={<SwapIcon />}
            showTagClose={false}
            className="min-w-max px-2.5"
            style={TAG_STYLE.OUTLINE}
            color={TAG_COLOR.DEFAULT}
            size={TAG_SIZE.MEDIUM}
            type={TAG_TYPE.ROUNDED}
            onClick={handleOpenSortItemsModal}
          >
            {activeSortLabel}
          </Tag>
        ) : null}
        <Tag
          startIcon={
            <TunningIcon
              className={classNames(
                filterCount > 0 ? "text-fds-brand" : "text-fds-secondary"
              )}
            />
          }
          showTagClose={false}
          className="min-w-max px-2.5"
          style={TAG_STYLE.OUTLINE}
          color={filterCount > 0 ? TAG_COLOR.BRAND : TAG_COLOR.DEFAULT}
          size={TAG_SIZE.MEDIUM}
          type={TAG_TYPE.ROUNDED}
          onClick={openExploreFilter}
          select={filterCount > 0}
        >{`فیلترها ${
          filterCount > 0 ? `(${toFarsiNumber(filterCount)})` : ""
        }`}</Tag>
        {Object.entries(visibleActiveFilters || {}).map(
          ([filterName, filterItem]) =>
            filterItem.filter_value?.map(
              (
                filterVal: { label: string; id: string; parentId?: number },
                idx: number
              ) => {
                const { label, id } = filterVal;
                const parentFilterLabel = filterItem.filter_label;
                const showingLabel =
                  label ||
                  (filterItem.filter_value?.length === 1 &&
                    (filterName === "term"
                      ? getTermLabel()
                      : parentFilterLabel));
                return (
                  <Tag
                    key={idx}
                    showTagClose={true}
                    id={filterName || ""}
                    className="min-w-max px-2.5 "
                    style={TAG_STYLE.OUTLINE}
                    size={TAG_SIZE.MEDIUM}
                    type={TAG_TYPE.ROUNDED}
                    color={TAG_COLOR.BRAND}
                    select={true}
                    handleCloseClick={() => {
                      removeFilterByValue(
                        filterName as ExploreFilterSchemaFields,
                        id
                      );
                    }}
                  >
                    {showingLabel}
                  </Tag>
                );
              }
            )
        )}
      </div>
    </div>
  );
};

export default ExploreMobileHeader;
